const users = {
    'BUYER_INDIVIDUAL': {
        name: 'BUYER',
        title: 'Buyer',
        type: 'INDIVIDUAL',
        key: 'BUYER_INDIVIDUAL'
    },
    'BUYER_CORPORATE_COMPANIES': {
        name: 'BUYER',
        title: 'Corporate Buyer',
        type: 'CORPORATE_COMPANIES',
        key: 'BUYER_CORPORATE_COMPANIES'
    },
    'SELLER_BUSINESSES': {
        name: 'SELLER',
        title: 'Seller',
        type: 'BUSINESSES',
        key: 'SELLER_BUSINESSES'
    },
    'SELLER_CORPORATE_COMPANIES': {
        name: 'SELLER',
        title: 'Corporate Seller',
        type: 'CORPORATE_COMPANIES',
        key: 'SELLER_CORPORATE_COMPANIES'
    },
    'CHARITY': {
        name: 'CHARITY',
        title: 'Charity',
        type: 'CHARITY',
        key: 'CHARITY'
    },
    'AFFILIATE': {
        name: 'AFFILIATE',
        title: 'Affiliate',
        type: 'AFFILIATE',
        key: 'AFFILIATE'
    }
}

export default users;